/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'skipped': {
    viewBox: '0 0 16 16',
    data: '<g><polygon points="8,10.5 12,8 8,5.5 8,7.5 0,7.5 0,8.5 8,8.5"/><path d="M15.2,4.6c-0.9-1.9-2.5-3.4-4.6-4.1c-2-0.7-4.2-0.6-6.1,0.3C2.6,1.7,1.2,3.3,0.5,5.3l0.9,0.3C2,3.9,3.3,2.5,5,1.7c1.7-0.8,3.6-0.9,5.3-0.3c1.8,0.6,3.2,1.9,4,3.6c0.8,1.7,0.9,3.6,0.3,5.3c-0.6,1.8-1.9,3.2-3.6,4c-1.7,0.8-3.6,0.9-5.4,0.3c-2-0.7-3.6-2.3-4.3-4.3l-0.9,0.3C1.3,13,3,14.7,5.3,15.5C6.2,15.9,7.1,16,8,16c1.2,0,2.3-0.3,3.4-0.8c1.9-0.9,3.4-2.5,4.1-4.6C16.3,8.7,16.1,6.5,15.2,4.6z"/></g>'
  }
})
